import { useEffect, useState } from 'react';

interface ColorCircleUIProps {
    value?: string
    onChange?: (value: string) => void
}
const colors = ['#000', '#EF4444'];
export default function ColorCircleUI(props: ColorCircleUIProps) {
    const [selectedColor, setSelectedColor] = useState(props.value ?? '#000');
    useEffect(() => { setSelectedColor(props.value ?? '#000') }, [props.value])
    return (
        <div className="flex mt-2 space-x-4">
            {colors.map((color) => (
                <div
                    key={color}
                    onClick={() => {
                        setSelectedColor(color)
                        props.onChange?.(color)
                    }}
                    className={`w-10 h-10 rounded-full cursor-pointer transition-all border-4 ${selectedColor === color
                        ? 'border-gray-500 scale-110'
                        : 'border-gray-300 hover:border-gray-400'
                        }`}
                    style={{ backgroundColor: color }}
                ></div>
            ))}
        </div>
    );
};